module.exports = require("scratch-translate-extension-languages");